import { useLayoutEffect, useRef, useState } from 'react';

/** Whether the element is narrower than `minWidth`, tracked as it resizes. Measures
 *  the element rather than the screen, because the same list sits in a narrow column
 *  on desktop and full width on a tablet. Where resizing can't be observed it reports
 *  wide. */
export function useNarrowContainer<T extends HTMLElement>(minWidth: number) {
  const ref = useRef<T>(null);
  const [narrow, setNarrow] = useState(false);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(([entry]) => {
      setNarrow(entry.contentRect.width < minWidth);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [minWidth]);
  return [ref, narrow] as const;
}
